<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="prod_id" [ttModel]="edit.prod_id" ttReadonly></tt-input>
        <tt-input ttLabel="prod_name" [ttModel]="edit.prod_name" ttReadonly></tt-input>
        <tt-input ttLabel="full_url" [(ttModel)]="edit.full_url" ttRequired></tt-input>
        <tt-image [hidden]="edit.full_url === ''" ttLabel="picture" [ttSrc]="edit.full_url"></tt-image>
        <tt-button-save ttText="productpic_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        <tt-button *ngIf="edit.productpicturebank_keyno !== '0'" ttText="productpic_delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
    </tt-card>
</tt-page>
